<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height ma-0 pa-0 >

        <v-flex xs12 >

          <v-layout fill-height column  ma-0 pt-0 >
           
            <scroll-area>

              <template slot="header">

                <v-toolbar class="active" :height="44" flat dark>
                  <v-toolbar-title>
                    <span class="body-2 uppercase blacktext--text">{{ $t('templates') }}</span>
                  </v-toolbar-title>
                </v-toolbar>

              </template>

              <template slot="body">

                <v-layout column fill-height justify-start ma-0 pt-1 >

                  <scroll-table
                    :data="getTable"
                    :options="getOptions"
                    :subscribed="false"
                    :headUppercase="false"
                    :sortable="true"
                    :sorted="sort"
                    :translate="true"
                    @sort="(item) => sortTable(item)"
                    @select=""
                    @value="(payload)=>onSelect(payload)"
                    @remove=""
                  />

                </v-layout>

              </template>

            </scroll-area>

          </v-layout>
        </v-flex>
        
      </v-layout>

    </v-layout>

    <v-dialog persistent v-model="dialog.open" max-width="1200px" v-if="dialog.open">
      <templates-card
        :data="getDialogData"
        :parentData="getData"
        @update="(payload) => onUpdate(payload)"
        @add=""
        @remove=""
        @close="() => onDialogClose()"
      />
    </v-dialog>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import templatesCard from '@/nms/pages/configuration/components/templates-card.vue'

// Типы
interface DialogState {
  open: boolean
  addMode: boolean
  name: string | null
  data: any | null
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface TableRow {
  id?: string
  description?: string
  device_type?: string
  manufacturer?: string
  name?: string
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: TableRow[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface TemplateItem {
  id?: string
  description?: string
  device_type?: string
  manufacturer?: string
  [key: string]: any
}

interface UpdateData {
  template?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'TEMPLATES',

  components: {
    scrollArea,
    scrollTable,
    templatesCard
  },

  props: {
    data: {
      type: Object as () => any,
      default: () => ({})
    },
  },

  data(): {
    dialog: DialogState
    sort: string
    model: Record<string, any>
    options: OptionsData
    search: string
    table: TableData
  } {
    return {
      dialog: {
        open: false,
        addMode: false,
        name: null,
        data: null,
      },
      sort: '',
      model: {},
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      table: {
        columns: [
          {
            title: 'name',
            value: 'id',
            type: 'text',
            width: '40%'
          },
          {
            title: 'description',
            value: 'description',
            type: 'text',
            width: '40%'
          },
          {
            title: 'device type',
            value: 'device_type',
            type: 'text',
            width: '20%'
          },
          {
            title: 'manufacturer',
            value: 'manufacturer',
            type: 'text',
            width: '20%'
          },
        ],
        rows: [],
      },
    }
  },

  computed: {
    getData(): any {
      return this.data
    },

    getDialogData(): any | null {
      return this.dialog.data
    },

    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData

      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.id?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.description?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.device_type?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.manufacturer?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }

      if (this.sort) {
        const isDescending = this.sort.charAt(0) === '-'
        const fieldName = isDescending ? this.sort.slice(1) : this.sort
        const direction = isDescending ? -1 : 1
        t.rows = [...t.rows].sort(this.$compare(fieldName, direction))
      }

      return t
    },

    getOptions(): OptionsData {
      return this.options
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.loadTemplates()
    },

    async loadTemplates(): Promise<void> {
      try {
        const templates = await this.$bridge.getTemplates('device') as TemplateItem[]
        if (templates) {
          this.prepareTable(templates)
        }
      } catch (error) {
        console.error(this.$options.name, 'loadTemplates smth wrong', error)
      }
    },

    async prepareTable(templates: TemplateItem[]): Promise<void> {
      if (!templates?.length) return

      try {
        const rows: TableRow[] = []
        templates.forEach(template => {
          rows.push(template)
        })
        this.$set(this.table, 'rows', rows)
      } catch (error) {
        console.error(this.$options.name, 'prepareTable smth wrong', error)
      }
    },

    async onSelect(val: TemplateItem): Promise<void> {
      if (!val) return
      this.$set(this.dialog, 'data', val)
      this.$set(this.dialog, 'open', true)
    },

    onDialogClose(): void {
      this.$set(this.dialog, 'data', null)
      this.$set(this.dialog, 'addMode', false)
      this.$set(this.dialog, 'open', false)
    },

    async onUpdate(val: UpdateData): Promise<void> {
      console.log(this.$options.name, 'onUpdate', 'val', val)
      if (!val?.template) return

      try {
        const u = await this.$bridge.customQuery('alarm', '/DHCP/changeJinjaPattern', val, 'put')
        if (u) {
          console.log(this.$options.name, 'onUpdate', 'u', u)
          this.$dialog.notify.success('update success', { timeout: 5000 })
          this.setup()
        } else {
          console.error('CATCH', 'TEMPLATES', 'onUpdate', 'smth wrong')
        }
      } catch (error) {
        console.error(this.$options.name, 'onUpdate smth wrong', error)
      }
    },

    sortTable(item: TableColumn): void {
      if (this.sort === item.value) {
        this.sort = '-' + item.value
      } else {
        this.sort = item.value
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
